import { Category } from './apiService';
import { Card, CategoryCardBody, Link, Text } from './styles';
import { getCategoryUrl, useResponsiveUrl } from './utils';

export default function CategoryCard({ short_id, title, slug, special_type, thumbnail_image_file: { path: image } = {} }: Category) {
  const imgUrl = useResponsiveUrl({ url: image, desktop: 500, mobile: 250 });
  return (
    <>
      <Card
        orientation="horizontal"
        as={Link}
        href={getCategoryUrl({ short_id, slug, special_type })}
        block
      >
        <CategoryCardBody style={{ backgroundImage: image && `url(${imgUrl})` }} />
      </Card>
      <Text variant="body1" as="h3" mt='0.5rem' mb='1rem'>{title}</Text></>
  );
}
